import { Stack, Button, Typography } from "@mui/material";
import { useState } from "react";
import Drawer from "../../ui/Drawer";
import { getAmenitiesIcon } from "../../utility/helper";
import AmenitiesDetails from "./amenity-details";
import React from "react";


const AvailableAmenitiesComponent: React.FC<{ availableAmenities: any[] }> = ({
	availableAmenities,
}) => {
	if (availableAmenities?.length === 0) return null;

	const [selected, setSelected] = useState<number | null>(null);
	const [openDrawer, toggleDrawer] = useState(false);

	const handleViewAmenity = (index: number | null) => {
		setSelected(index);
		toggleDrawer(!openDrawer);
	};

	const getAmenityTypeText = (amenityTypeName: any) => {
		return amenityTypeName === "Beache Access" ? "Beach Access" : amenityTypeName;
	};

	return (
		<>
			<Stack>
				<span className="text-3E3E3E-18px bold">Available Amenities</span>
				<Stack mt={2} direction={"row"} gap={2} flexWrap={"wrap"}>
					{availableAmenities.map((availableAmenity: any, index: number) => {
						const amenityTypeName = availableAmenity?.amenityType;
						return (
							<Button
								key={index}
								sx={{
									borderColor: selected === index ? "#3576E5" : "#E8E8E8",
									background: selected === index ? "#EFF4FC" : "#FFFFFF",
									color: "#3E3E3E",
									width: "163px",
									height: "96px",
									"&:hover": { borderColor: "#3576E5 !important" },
								}}
								variant="outlined"
								onClick={() => handleViewAmenity(index)}
							>
								<div className="amenity-container">
									{React.createElement(getAmenitiesIcon(amenityTypeName), {
										color: "primary",
									})}
									<Typography className="amenity-text">
										{getAmenityTypeText(amenityTypeName)}
									</Typography>
								</div>
							</Button>
						);
					})}
				</Stack>
			</Stack>
			<Drawer
				open={openDrawer}
				closeDrawer={() => {
					handleViewAmenity(null);
				}}
			>
				{openDrawer && (
					<AmenitiesDetails
						handleClose={() => handleViewAmenity(null)}
						details={availableAmenities[selected] || {}}
						getAmenityTypeText={getAmenityTypeText}
					/>
				)}
			</Drawer>
		</>
	);
};

export default AvailableAmenitiesComponent;